import { Divider, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { FormProvider, useForm } from "react-hook-form";
import { FilterCriteria } from "./FilterCriteria";
import { OtherSettings } from "./OtherSettings";
import config from "../../Config/clientConfig.json";
import WSSelectField from "../../Components/Select/WSSelect";
import WSDateField from "../../Components/DateField/WSDateField";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { WSIcons } from "../../commonFunctions/iIcons";

export const TimeWiseReport:React.FC<any>=React.memo((props)=>{
  const { handleSubmit, control, register,setValue, getValues } = useForm();
  const [nValue, setNValue] = useState(0); 


      const onSubmit = async (data: any) => {
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };

      const handleIncrement = () => {
        const currentValue = getValues("n="); // Get current value from form
        const newValue = (currentValue ? parseInt(currentValue) : 0) + 5;
        setValue("n=", newValue); // Update the form value using setValue
        setNValue(newValue); // Also update internal state to keep track
      };
    
      const handleDecrement = () => {
        const currentValue = getValues("n="); // Get current value from form
        const newValue = (currentValue ? parseInt(currentValue) : 0) - 5;
        setValue("n=", newValue < 0 ? 0 : newValue); // Prevent the value from going below 0
        setNValue(newValue < 0 ? 0 : newValue); // Update internal state accordingly
      };
    return(
              <form onSubmit={handleSubmit(onSubmit)}  style={{ width: '100%' }}>

                <Typography sx={{fontWeight: 500,fontSize: "0.875rem",color:"#1976d2"}}>FILTER CRITERIA</Typography>
                <Divider sx={{mt:1}}/>
                <Grid container spacing={2} sx={{mt:3}}>

      <Grid item xs={12} sm={2}>
        <Typography> Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="date"
          name="date"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>To Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="todate"
          name="todate"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Time</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
      <WSTextField
            label={""}
            {...register("time")}
            id="time"
            name="time"
            control={control}
            rules={{ required: false }}/>
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>To Time</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
      <WSTextField
            label={""}
            {...register("totime")}
            id="totime"
            name="totime"
            control={control}
            rules={{ required: false }}/>
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Outlet</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSSelectField
          rules={{ required: true }}
          {...register("outlet")}
          id="outlet"
          control={control}
          defaultValue={"0"}
          label=""
          name="outlet"
          options={config.outletConfig.staticOptionData}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
      <Typography>n =</Typography>
      </Grid>
            <Grid item xs={12} sm={4}>
      <Grid display="flex" alignItems="center">
                    {/* Text Field */}
                    <WSTextField
                        label={""}
                        {...register("n=")}
                        id="n="
                        name="n="
                        control={control}
                        rules={{ required: false }}
                    />

                    {/* Icons */}
                    <Grid display="flex" ml={1}>
                        <IconButton onClick={handleIncrement}>
                            <WSIcons.AddIcon />
                        </IconButton>
                        <IconButton onClick={handleDecrement}>
                            <WSIcons.Minus />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
            <WSSCheckBoxField
          id="showtimeinrange"
          name="showtimeinrange"
          label="Show Time in range of {n} minute"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
            </Grid>
            <Grid item xs={12}>
            <WSSCheckBoxField
          id="consolidateitems"
          name="consolidateitems"
          label="Consolidate items on date change"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
            </Grid>
            <Grid item xs={12}>
            <WSSCheckBoxField
          id="ignoremodifier"
          name="ignoremodifier"
          label="Ignore Modifier Without Cost"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
            </Grid>
            <Grid item xs={12}>
            <WSSCheckBoxField
          id="ignorenocharge"
          name="ignorenocharge"
          label="Ignore No Charge"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
            </Grid>
            <Grid item xs={12}>
            <WSSCheckBoxField
          id="showpayment"
          name="showpayment"
          label="Show Item Modified Name"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
            </Grid>
      </Grid>
            </form>
    )
})